import TrelloApi from "@/api/admin/trello";
// initial state
const state = () => ({
  boards: [],
})

// getters
const getters = {
  boards: (state) => state.boards,
}

// actions
const actions = {
  async loadBoards ({ commit }) {
    const result = await TrelloApi.getBoards()
    const boards = result.data.map(board => {
      // return { id: board.id, name: board.name, shortUrl: board.shortUrl }
      return board
    })
    console.log(boards)
    commit('setBoards', boards)
  },
}

// mutations
const mutations = {
  setBoards (state, boards) {
    state.boards = boards
  },
  clearBoards (state) {
    state.boards = []
  },}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
